export const GENERAL = "general";
export const GENERAL_NAME = "name";
export const GENERAL_CATEGORY_ID = "categoryId";
export const GENERAL_SUB_CATEGORY_ID = "subCategoryId";
export const GENERAL_MANUFACTURER_ID = "manufacturerId";
export const GENERAL_MODEL_ID = "modelId";
export const GENERAL_MAX_PAYLOAD = "maxPayload";
export const GENERAL_MAX_VOLUME = "maxVolume";
export const GENERAL_INTERIOR_LENGTH = "interiorLength";
export const GENERAL_INTERIOR_WIDTH = "interiorWidth";
export const GENERAL_INTERIOR_HEIGHT = "interiorHeight";

// Images TAB
export const IMAGES = "vehicleTypeImages";
export const IMAGES_ID = "id";
export const IMAGES_IS_DEFAULT = "isDefault";
export const IMAGES_URL = "imageUrl";
export const IMAGES_THUMBNAIL = "imageThumbnail";

export const TABS = [GENERAL, IMAGES];
